import { CONTACT } from 'components/HelpModal/constants';

const IdealContact: React.FunctionComponent = function () {
  return (
    <div className="flex flex-col gap-y-3">
      {CONTACT.map((row) => (
        <div className="flex flex-col" key={row.title}>
          <h4 className="text-16-20-em mb-1">{row.title}</h4>
          {row.tel && (
            <h5 className="text-14-22">
              Tel:{' '}
              <a
                className="text-blue-200 underline font-bold"
                href={`tel:${row.tel}`}
              >
                {row.tel}
              </a>
            </h5>
          )}
          {row.email && (
            <h5 className="text-14-22">
              Email:{' '}
              <a
                className="text-blue-200 underline font-bold"
                href={`mailto:${row.email}`}
              >
                {row.email}
              </a>
            </h5>
          )}
          {row.comment && <h5 className="text-14-22">{row.comment}</h5>}
        </div>
      ))}
    </div>
  );
};

export default IdealContact;
